import React, { FC } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '../../../../../assets/icons/InfoIcon';
import './SettingBox.scss';

interface SettingBoxProps {
    children: React.ReactElement;
    title: string;
    /** i18n key (without creativeDetail- prefix) for optional hover tooltip next to the label */
    tooltipKey?: string;
}

export const SettingBox: FC<SettingBoxProps> = ({ children, title, tooltipKey }) => {
    const { t } = useTranslation();

    const prefix = 'creativeDetail-';

    return (
        <div className="d-block d-lg-flex align-items-center my-3">
            <div className="col-lg-4 col pb-0 pb-lg-3 pb-lg-0 ps-0">
                <div className="d-flex align-items-center gap-2">
                    <span>{t(prefix + title.toLowerCase())}</span>
                    {tooltipKey ? (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{t(prefix + tooltipKey)}</Tooltip>}
                        >
                            <Button variant="link" className="p-0 lh-1">
                                <InfoIcon width={18} height={18} />
                            </Button>
                        </OverlayTrigger>
                    ) : null}
                </div>
            </div>
            <div className="col px-0">
                <div className="settingInputContainer">{children}</div>
            </div>
        </div>
    );
};
